import { CLIENT_ID } from "@api/client-id";
import { ProjectApi } from "@api/project-api/project-api";
import { useCachedTokenProvider } from "@api/use-cached-token-provider";
import { BaseProjectIdProps } from "@custom-types/base-types";
import { runtimeConfig } from "@src/runtime-config";
import { useMemo } from "react";

/** Custom hook that initializes the project API client and returns an instance of it */
export function useProjectApiClient({
  projectId,
}: BaseProjectIdProps): ProjectApi {
  const tokenProvider = useCachedTokenProvider({
    projectId,
  });

  // Make sure the client is only created once, unless projectId or token provider change
  return useMemo(
    () =>
      new ProjectApi({
        projectApi: new URL(runtimeConfig.urls.projectApiUrl),
        projectId,
        tokenProvider,
        clientId: CLIENT_ID,
      }),
    [projectId, tokenProvider]
  );
}
